// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-articles-js": require("gatsby-module-loader?name=component---src-pages-articles-js!/Users/diljith/Workspace/Gatsby/StaticSite/livshutz/src/pages/articles.js"),
  "component---src-pages-contact-js": require("gatsby-module-loader?name=component---src-pages-contact-js!/Users/diljith/Workspace/Gatsby/StaticSite/livshutz/src/pages/contact.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/Users/diljith/Workspace/Gatsby/StaticSite/livshutz/src/pages/index.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/Users/diljith/Workspace/Gatsby/StaticSite/livshutz/.cache/json/layout-index.json"),
  "articles.json": require("gatsby-module-loader?name=path---articles!/Users/diljith/Workspace/Gatsby/StaticSite/livshutz/.cache/json/articles.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/Users/diljith/Workspace/Gatsby/StaticSite/livshutz/.cache/json/layout-index.json"),
  "contact.json": require("gatsby-module-loader?name=path---contact!/Users/diljith/Workspace/Gatsby/StaticSite/livshutz/.cache/json/contact.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/Users/diljith/Workspace/Gatsby/StaticSite/livshutz/.cache/json/layout-index.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/Users/diljith/Workspace/Gatsby/StaticSite/livshutz/.cache/json/index.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/Users/diljith/Workspace/Gatsby/StaticSite/livshutz/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js